import { RootStores } from '../../common/stores';
import { STORE_WEB_REQUEST_CONSOLE } from './constants';
import WebRequestConsoleStore from './WebRequestConsoleStore';
import WebRequestConsoleService from '../services/WebRequestConsoleService';

export { default as WebRequestConsoleStore } from './WebRequestConsoleStore';

export function injectWebRequestConsoleStores(obj: RootStores) {
    const service = new WebRequestConsoleService();
    obj[STORE_WEB_REQUEST_CONSOLE] = new WebRequestConsoleStore(service);
}

export type WebRequestConsoleStores = {
    [STORE_WEB_REQUEST_CONSOLE]?: WebRequestConsoleStore;
};
